<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    labelBack="Atrás"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                  prepend-inner-icon="fas fa-number"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
                    
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import Upload from "@/components/Upload";
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm, Upload},
    computed: {
      ...mapState({
        status: state => state.Specialities.status,
      })
    },
    data() {
      return {
        storeName: 'Specialities',
        title: "Especialidades",
        parentStoreName:'Jobs',
        parentUrlKey:'job_id',
        data: {
          job_id: '',
          name: '',
        }
      }
    },
    created() {
      const self = this;

      if (this.$route.params.job_id)
        this.data.job_id = this.$route.params.job_id;
      if (this.$route.params.id) {
        this.$store
          .dispatch(`${this.storeName}/show`, this.$route.params.id)
          .then(function(data) {
            for (let i in data) {
              if (
                self.data[i] !== undefined &&
                !self.filteredAttributes.includes(i)
              ) {
                self.data[i] = data[i];
              } else {
                if (
                  self.filteredAttributes.includes(i) &&
                  self[i] !== undefined
                ) {
                  self[i] = data[i];
                }
              }
            }
          });
      }
    },
    methods: {
      
    },
  }
</script>
